import { RestSlice } from '../../../../redux/rest.slice';
import { localizationService, Resource } from 'src/services';
import { Incident } from '@rcp/types';

export const incidentsSlice = new RestSlice<Incident>(
	localizationService.getLocalizedString('incidents.incidents'),
	Resource.Incidents
);
export const incidentsReducer = incidentsSlice.rests.reducer;
